<template>
  <div class="page-history">
    <div class="nav-header flex flex-main-justify flex-cross-center">
      <img src="../assets/img/stl_logo.png" alt="" />
      <h1>Crime Dashboard</h1>
      <el-button @click="PUSH({ name: 'index' })">USER GUIDE</el-button>
    </div>
    <div class="select-header flex">
      <div class="select-box select-date-range-box">
        <p>DateRange</p>
        <div class="select-date-range flex">
          <el-date-picker
            v-model="dateRange"
            type="daterange"
            range-separator="~"
            start-placeholder="Start date"
            end-placeholder="End date"
            @change="getData"
            :clearable="false"
          >
          </el-date-picker>
          <!-- <el-date-picker
            v-model="startDate"
            type="date"
            placeholder="select"
          >
          </el-date-picker>
          <i class="sign">~</i>
          <el-date-picker v-model="endDate" type="date" placeholder="select">
          </el-date-picker> -->
        </div>
      </div>
      <div class="select-box select-crime-type-box">
        <p>CrimeType</p>
        <el-select
          v-model="selectedCrimeType"
          placeholder="select"
          @change="getData"
        >
          <el-option
            v-for="item in crimeTypeOption"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </div>
      <div class="select-box select-community-area-box">
        <p>Community Area</p>
        <el-select
          v-model="selectedCommunityArea"
          placeholder="select"
          @change="getData"
        >
          <el-option
            v-for="item in communityAreaOption"
            :key="item.value"
            :label="item.value"
            :value="item.label"
          >
          </el-option>
        </el-select>
      </div>
      <div class="select-box select-map-type-box">
        <p>MapType</p>
        <el-radio-group v-model="selectedMapType" @change="getData">
          <el-radio :label="'choropleth'">Choropleth</el-radio>
          <el-radio :label="'point'">Point</el-radio>
          <el-radio :label="'density'">Density</el-radio>
        </el-radio-group>
      </div>
    </div>
    <div class="history-content flex">
      <div class="map-box public-style" id="map"></div>
      <div class="chart-content">
        <div class="header flex">
          <div class="public-style info-box">
            <h4>{{ selectedArea }}</h4>
            <p>Selected Area</p>
          </div>
          <div class="public-style info-box">
            <h4>{{ totalCrimes }}</h4>
            <p>Total number of crimes</p>
          </div>
        </div>
        <div class="line-box public-style">
          <p class="title">by Date</p>
          <div id="line-chart"></div>
        </div>
        <div class="bar-content flex">
          <div class="bar-one public-style">
            <p class="title">by Type</p>
            <div id="type-chart"></div>
          </div>
          <div class="bar-one public-style">
            <p class="title">by Arrest</p>
            <div id="arrest-chart"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Echarts from "echarts";
import AreaData from "../assets/Chicago_geojson.geojson";
import IconRobbery from "../assets/img/icon-robbery.svg";
import IconBurglary from "../assets/img/icon-burglary.svg";
import IconAssault from "../assets/img/icon-assault.svg";
import IconCriminalDamage from "../assets/img/icon-criminal-damage.svg";
import IconMotorVehicleTheft from "../assets/img/icon-motor-vehicle-theft.svg";
export default {
  data() {
    return {
      dateRange: ["2017-01-01", "2017-03-01"],
      startDate: "2017-01-01",
      endDate: "2017-03-01",
      selectedCrimeType: "-All-",
      selectedCommunityArea: "-All-",
      selectedMapType: "choropleth",
      crimeTypeOption: [
        {
          value: "-All-",
          label: "-All-"
        },
        {
          value: "ASSAULT",
          label: "ASSAULT"
        },
        {
          value: "BURGLARY",
          label: "BURGLARY"
        },
        {
          value: "CRIMINAL DAMAGE",
          label: "CRIMINAL DAMAGE"
        },
        {
          value: "MOTOR VEHICLE THEFT",
          label: "MOTOR VEHICLE THEFT"
        },
        {
          value: "ROBBERY",
          label: "ROBBERY"
        }
      ],
      communityAreaOption: [],
      selectedArea: "-All-",
      totalCrimes: 0,
      dataByDate: [],
      dataByArrest: [],
      dataByType: [],
      mapAreaData: [],
      mapOptions: {
        center: {
          lat: AreaData.features[0].geometry.coordinates[0][0][0][1],
          lng: AreaData.features[0].geometry.coordinates[0][0][0][0]
        },
        zoom: 10,
        styles: [
          {
            featureType: "all",
            elementType: "labels.text.fill",
            stylers: [
              {
                saturation: 36
              },
              {
                color: ""
              },
              {
                lightness: 40
              }
            ]
          },
          {
            featureType: "all",
            elementType: "labels.text.stroke",
            stylers: [
              {
                visibility: "on"
              },
              {
                color: ""
              },
              {
                lightness: 16
              }
            ]
          },
          {
            featureType: "all",
            elementType: "labels.icon",
            stylers: [
              {
                visibility: "off"
              }
            ]
          },
          {
            featureType: "administrative",
            elementType: "geometry.fill",
            stylers: [
              {
                color: ""
              },
              {
                lightness: 20
              }
            ]
          },
          {
            featureType: "administrative",
            elementType: "geometry.stroke",
            stylers: [
              {
                color: ""
              },
              {
                lightness: 17
              },
              {
                weight: 1.2
              }
            ]
          },
          {
            featureType: "landscape",
            elementType: "geometry",
            stylers: [
              {
                color: ""
              },
              {
                lightness: 20
              }
            ]
          },
          {
            featureType: "poi",
            elementType: "geometry",
            stylers: [
              {
                color: ""
              },
              {
                lightness: 21
              }
            ]
          },
          {
            featureType: "road.highway",
            elementType: "geometry.fill",
            stylers: [
              {
                color: ""
              },
              {
                lightness: 17
              }
            ]
          },
          {
            featureType: "road.highway",
            elementType: "geometry.stroke",
            stylers: [
              {
                color: ""
              },
              {
                lightness: 29
              },
              {
                weight: 0.2
              }
            ]
          },
          {
            featureType: "road.arterial",
            elementType: "geometry",
            stylers: [
              {
                color: ""
              },
              {
                lightness: 18
              }
            ]
          },
          {
            featureType: "road.local",
            elementType: "geometry",
            stylers: [
              {
                color: ""
              },
              {
                lightness: 16
              }
            ]
          },
          {
            featureType: "transit",
            elementType: "geometry",
            stylers: [
              {
                color: ""
              },
              {
                lightness: 19
              }
            ]
          },
          {
            featureType: "water",
            elementType: "geometry",
            stylers: [
              {
                color: ""
              },
              {
                lightness: 17
              }
            ]
          }
        ]
      },
      pointColorOption: {
        ROBBERY: "rga(161, 168, 252)",
        BURGLARY: "rga(245, 153, 137)",
        ASSAULT: "rga(102, 224, 192)",
        "CRIMINAL DAMAGE": "rga(205, 161, 252)",
        "MOTOR VEHICLE THEFT": "rga(255, 199, 156)"
      },
      mapAreaSelected: false,
      mapAreaSelectedId: ""
    };
  },
  mounted() {
    this.getAreaData();
    // this.getMapsUpdate();
  },
  methods: {
    // 获取地图数据
    getMapsUpdate() {
      // this.selectedMapType = "density";
      let param = {
        startDate: this.$dayjs(this.dateRange[0]).format("YYYY-MM-DD"),
        endDate: this.$dayjs(this.dateRange[1]).format("YYYY-MM-DD"),
        selCrime: this.selectedCrimeType,
        selArea: this.selectedCommunityArea,
        // "selLayer": "choropleth"
        // "selLayer": "point"
        // selLayer: "density"
        selLayer: this.selectedMapType
      };
      this.$http.post("/apis/api/maps_update", param).then((res) => {
        console.log(res, "mapsdata");
        this.mapAreaData = res.data;
        if (this.selectedMapType == "choropleth") {
          this.renderAreaMap();
        } else if (this.selectedMapType == "point") {
          this.renderPointMap();
        } else {
          this.renderDensityMap();
        }
      });
    },
    renderDensityMap() {
      this.mapOptions.mapTypeId = "satellite";
      let map = new google.maps.Map(
        document.getElementById("map"),
        this.mapOptions
      ); // 创建谷歌地图
      const getPoints = () => {
        return this.mapAreaData.map((item) => {
          if (item.Latitude) {
            return new google.maps.LatLng(item.Latitude, item.Longitude);
          }
        });
      };
      let heatmap = new google.maps.visualization.HeatmapLayer({
        data: getPoints(),
        map: map,
        dissipating: true
      });
      let gradient = [
        // "rgba(255,247,236,0)",
        "rgba(254,232,200,0)",
        "rgba(253,212,158,1)",
        "rgba(253,187,132,1)",
        "rgba(252,141,89,1)",
        "rgba(239,101,72,1)",
        "rgba(215,48,31,1)",
        "rgba(179,0,0,1)",
        "rgba(127,0,0,1)"
      ];
      heatmap.set("gradient", gradient);
    },
    renderPointMap() {
      let map = new google.maps.Map(
        document.getElementById("map"),
        this.mapOptions
      ); // 创建谷歌地图
      let url = "";
      let marker = [];
      let infowindow = [];
      this.mapAreaData.forEach((item, index) => {
        switch (item["Primary.Type"]) {
          case "ROBBERY":
            url = IconRobbery;
            break;
          case "BURGLARY":
            url = IconBurglary;
            break;
          case "ASSAULT":
            url = IconAssault;
            break;
          case "GRIMINAL DAMAGE":
            url = IconCriminalDamage;
            break;
          case "MOTOR VEHICLE THEFT":
            url = IconMotorVehicleTheft;
            break;
          default:
            break;
        }
        marker[index] = new google.maps.Marker({
          map: map,
          icon: {
            url,
            scaledSize: new google.maps.Size(5, 5)
          },
          position: new google.maps.LatLng(item.Latitude, item.Longitude),
          title:
            "Latitude:" + item.Latitude + ` ` + "Longitude:" + item.Longitude
        });
        infowindow[index] = new google.maps.InfoWindow({ content: "Primary.Type: " + item['Primary.Type'] + "<br>Latitude: " + item.Latitude + "<br>Longitude: " + item.Longitude });
        //使用谷歌地图定义的事件，给这个marker添加点击事件
        google.maps.event.addListener(marker[index], "mouseover", function () {
          infowindow[index].open(map, marker[index]);
        });
        google.maps.event.addListener(marker[index], "mouseout", function () {
          infowindow[index].close(map, marker[index]);
        });
      });
    },
    renderAreaMap() {
      let map = new google.maps.Map(
        document.getElementById("map"),
        this.mapOptions
      ); // 创建谷歌地图

      let areaArr = [];
      // 当前区域
      let currentArea = {};
      // 各区域最大值
      let max = Math.max(
        ...this.mapAreaData.map((item) => {
          return item.counts;
        })
      );
      let self = "";
      let infoWindow = "";
      let $this = this;
      AreaData.features.forEach((item) => {
        areaArr = [];
        item.geometry.coordinates[0][0].forEach((item) => {
          areaArr.push({
            lat: item[1],
            lng: item[0]
          });
        });
        currentArea = this.mapAreaData.find((ele) => {
          return ele.Community_Area_Num == item.properties.Community_Area_Num;
        });
        if (currentArea) {
          let color = "";
          let num = 1 - currentArea.counts / max;
          if (currentArea.counts / max > 0.9) {
            if (num < 0.5) {
              num = 0.5;
            }
            color = "rgb(" + parseInt(255 * num) + ", 0, 0)";
          } else {
            color =
              "rgb(" +
              parseInt(255) +
              ", " +
              parseInt(255 * (1 - currentArea.counts / max)) +
              ", " +
              parseInt(190 * (1 - currentArea.counts / max)) +
              ")";
          }
          self = new google.maps.Polygon({
            paths: areaArr,
            strokeColor: "#000000",
            strokeOpacity: 0.8,
            strokeWeight: 2,
            fillColor: color,
            fillOpacity: 1,
            info: currentArea
          });
          self.setMap(map);
          infoWindow = new google.maps.InfoWindow();
          self.addListener("mouseover", showArrays);
          self.addListener("mouseout", hideArrays);
          self.addListener("click", selectArea);
        }
      });

      function showArrays(event) {
        let item = this.info;
        let contentString =
          "Community.Area: " +
          item['Community.Area'] + 
          "<br>Community_Area: " +
          item.Community_Area +
          "<br>Population_2010: " +
          item.Population_2010 +
          "<br>Counts: " +
          item.counts;
        infoWindow.setContent(contentString);
        infoWindow.setPosition(event.latLng);
        infoWindow.open(map);
      }
      function hideArrays(event) {
        infoWindow.close(map);
      }
      function selectArea() {
        $this.mapAreaSelected = true;
        $this.mapAreaSelectedId = this.info['Community.Area'];
        $this.getData();
      }
    },
    getAreaData() {
      this.$http.get("/apis/api/sel_area_name", {}).then((res) => {
        console.log(res, "sel_area_name");
        for (let k in res.data) {
          this.communityAreaOption.push({
            value: k,
            label: res.data[k]
          });
        }
        this.selectedCommunityArea = this.communityAreaOption[0].label;
        this.getData();
      });
    },
    getData() {
      let param = {
        startDate: this.$dayjs(this.dateRange[0]).format("YYYY-MM-DD"),
        endDate: this.$dayjs(this.dateRange[1]).format("YYYY-MM-DD"),
        sel_Crime: this.selectedCrimeType,
        sel_Area: this.mapAreaSelected ? this.mapAreaSelectedId : this.selectedCommunityArea,
        sel_layer: this.selectedMapType
      };
      this.$http.post("/apis/api/charts_update", param).then((res) => {
        console.log(res, "charts_update");
        let data = res.data;
        this.totalCrimes = data.total_crimes;
        this.selectedArea = data.sel_Area_Name;
        this.dataByDate = data.countsByDate;
        this.dataByArrest = data.countsByArrest;
        this.dataByType = data.countsByType;
        this.renderLine();
        this.renderTypeChart();
        this.renderArrestChart();
        if (!this.mapAreaSelected) {
          this.getMapsUpdate();
        } else {
          this.mapAreaSelected = false;
        }
      });
    },
    renderLine() {
      // 基于准备好的dom，初始化echarts实例
      let myChart = Echarts.init(document.getElementById("line-chart"));
      // 绘制图表
      myChart.setOption({
        tooltip: {},
        xAxis: {
          data: this.dataByDate.map((item) => {
            return item[0];
          })
        },
        tooltip: {
          trigger: "axis",
          formatter: function (item) {
            return "count : " + item[0].value + "<br/>" + item[0].name;
          }
        },
        color: ["rgb(99, 110, 250)"],
        yAxis: {},
        series: [
          {
            name: "counts",
            type: "bar",
            data: this.dataByDate.map((item) => {
              return item[1];
            })
          }
        ]
      });
    },
    renderTypeChart() {
      // 基于准备好的dom，初始化echarts实例
      let myChart = Echarts.init(document.getElementById("type-chart"));
      // 绘制图表
      myChart.setOption({
        tooltip: {},
        xAxis: {
          show: false
        },
        yAxis: {
          show: false
        },
        color: [
          "rgb(99, 110, 250)",
          "rgb(239, 85, 59)",
          "rgb(39, 167, 150)",
          "rgb(171, 99, 250)",
          "rgb(255, 161, 90)"
        ],
        legend: {
          data: this.dataByType.map((item) => {
            return item[0];
          }),
          orient: "vertical",
          left: "40",
          bottom: "0"
        },
        series: [
          {
            type: "pie", // 设置图表类型为饼图
            radius: "55%", // 饼图的半径，外半径为可视区尺寸（容器高宽中较小一项）的 55% 长度。
            data: this.dataByType.map((item) => {
              return {
                value: item[1],
                name: item[0]
              };
            }),
            itemStyle: {
              normal: {
                label: {
                  show: true,
                  position: "inner",
                  formatter: "{d}%"
                }
              }
            }
          }
        ]
      });
    },
    renderArrestChart() {
      // 基于准备好的dom，初始化echarts实例
      let myChart = Echarts.init(document.getElementById("arrest-chart"));
      // 绘制图表
      myChart.setOption({
        tooltip: {},
        xAxis: {
          show: false,
          boundaryGap: [0, 0]
        },
        yAxis: {
          show: false,
          boundaryGap: [0, 0]
        },
        color: ["rgb(239, 85, 59)", "rgb(99, 110, 250)"],
        legend: {
          data: this.dataByArrest.map((item) => {
            return item[0] + "";
          }),
          bottom: "0",
          left: "40"
        },
        grid: {
          left: 0,
          right: 0,
          top: 0,
          bottom: 0
        },
        series: [
          {
            type: "pie", // 设置图表类型为饼图
            radius: "55%", // 饼图的半径，外半径为可视区尺寸（容器高宽中较小一项）的 55% 长度。
            data: this.dataByArrest.map((item) => {
              return {
                value: item[1],
                name: item[0] + ""
              };
            }),
            itemStyle: {
              normal: {
                label: {
                  show: true,
                  position: "inner",
                  formatter: "{d}%"
                }
              }
            }
          }
        ]
      });
    }
  }
};
</script>

<style lang="scss">
.page-history {
  padding: 40px 100px 0 100px;
  background-color: #f2f2f2;
  overflow-y: auto;
  .public-style {
    background-color: #fff;
    box-shadow: 2px 2px 2px lightgrey;
  }
  .nav-header {
    height: 100px;
    margin-bottom: 20px;
    img {
      width: 200px;
    }
    h1 {
      font-size: 0.4rem;
    }
  }
  .select-header {
    .select-box {
      box-shadow: 2px 2px 2px lightgrey;
      margin-right: 20px;
      background-color: #fff;
      padding: 10px;
      p {
        font-size: 0.16rem;
        margin-bottom: 10px;
      }
      &.select-date-range-box {
        width: 30%;
        .sign {
          line-height: 40px;
          margin: 0 16px;
        }
      }
      &.select-crime-type-box {
        width: 20%;
      }
      &.select-community-area-box {
        width: 20%;
      }
      &.select-map-type-box {
        width: 30%;
      }
      &:last-child {
        margin-right: 0;
      }
    }
  }
  .history-content {
    width: 100%;
    height: 1220px;
    margin-left: 0;
    margin-top: 20px;
    padding-top: 20px;
    padding-bottom: 40px;
  }
  .line-box {
    padding-top: 20px;
    margin-top: 20px;
    margin-bottom: 20px;
  }
  .map-box {
    width: 58%;
    height: 100%;
    margin-right: 2%;
  }
  .chart-content {
    width: 40%;
    .header {
      .info-box {
        margin-right: 20px;
        padding-left: 10px;
        h4 {
          font-size: 0.3rem;
        }
        p {
          font-size: 0.16rem;
        }
        &:last-child {
          margin-right: 0;
        }
      }
    }
  }
  .header {
    width: 100%;
    div {
      width: 50%;
      padding: 20px 10px;
      box-shadow: 2px 2px 2px lightgrey;
      h4 {
        font-size: 0.16rem;
      }
    }
  }
  #line-chart {
    width: 100%;
    height: 400px;
  }
  .bar-one {
    width: 50%;
    height: 534px;
    background-color: #fff;
    padding-bottom: 30px;
    &:first-child {
      margin-right: 20px;
    }
  }
  #type-chart,
  #arrest-chart {
    width: 100%;
    height: 440px;
  }
  .title {
    font-size: 0.16rem;
    margin: 0.2rem 0 0.2rem 0.4rem;
  }
}
</style>
